import { render, staticRenderFns } from "./endowments.vue?vue&type=template&id=5a6149e8&scoped=true&"
import script from "./endowments.vue?vue&type=script&lang=js&"
export * from "./endowments.vue?vue&type=script&lang=js&"
import style0 from "./endowments.vue?vue&type=style&index=0&id=5a6149e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6149e8",
  null
  
)

export default component.exports